<script setup>
import Typography from '@components/Typography.vue';
import { useScreensizeStore } from '@stores/useScreensizeStore';
import { storeToRefs } from 'pinia';

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  iconClass: {
    type: String,
    default: null,
  },
  link: {
    type: String,
    default: null,
  },
  linkTitle: {
    type: String,
    default: null,
  },
});

const { isMobile } = storeToRefs(useScreensizeStore());
</script>

<template>
  <div
    class="encourage-stripe-explanation__block encourage-stripe-explanation-block"
    :class="iconClass ? `encourage-stripe-explanation-block--${iconClass}` : ''"
  >
    <div class="encourage-stripe-explanation-block__content">
      <span class="encourage-stripe-explanation-block__title">
        {{ title }}
      </span>
      <span class="encourage-stripe-explanation-block__description">
        {{ description }}
      </span>
      <a
        v-if="link"
        :href="link"
        :target="isMobile ? '_self' : '_blank'"
        class="encourage-stripe-explanation-block__link"
      >
        <Typography variant="body-bold" color="gray-darker">
          {{ linkTitle }}
        </Typography>
      </a>
    </div>
  </div>
</template>
